import React from 'react';
import PushUpsStreak from './PushUpsStreak';

import styled from 'styled-components'

const GridContainer = styled.div`
    display: grid;
    grid-template-columns: 50% 50%;
    gap: 20px;
    background-color: transparent;
    width: 100%;
    height: 100vh;
    max-height: 100vh;
    overflow: hidden;
    padding: 20px;
    padding-right: 40px;
    box-sizing: border-box;
`;

const PushUpsStreakStyled = styled.div`
    background-color: white;
    box-shadow: 0px 3px 7px rgba(0, 0, 0, 0.5);
    border-radius: 10px;
    overflow: hidden;
`;



const PushUpsContainer = props => {
    return (
        <GridContainer>
            <PushUpsStreakStyled><PushUpsStreak person="Jenny" imageSource="/images/Jenny.png" /></PushUpsStreakStyled>
            <PushUpsStreakStyled><PushUpsStreak person="Sivert" imageSource="/images/Sivert.png" /></PushUpsStreakStyled>
            <PushUpsStreakStyled><PushUpsStreak person="Espen" imageSource="/images/Espen.png" /></PushUpsStreakStyled>
            <PushUpsStreakStyled><PushUpsStreak person="Britt" imageSource="/images/britt.jfif" /></PushUpsStreakStyled>
        </GridContainer>
    );
};

export default PushUpsContainer;
